export default __webpack_public_path__ + "static/media/image-02.4ad7d585.jpg";